<template>
  <DialogCmp @click-outside="$emit('click-outside')" :showDialog="showDialog" :dialogClass="containerClass">
    <template slot="header">
      <div class="header-title">{{customTitle || $t('common.dialog.confirm')}}</div>
    </template>

      <template slot="content">
        <slot name="content">
          <div class="dialog-content" slot="content">
            {{content}}
          </div>
        </slot>
      </template>

    <template slot="footer">
      <DialogBtn
        v-for="action in actions"
        :key='action.action'
        @click="actionClicked(action.action)">
          {{action.label}}
      </DialogBtn>
    </template>
  </DialogCmp>
</template>

<script>
  import DialogCmp from './dialog/DialogCmp'
  import DialogBtn from './dialog/DialogBtn'

  export default {
    deprecated: 'Please use VcConfirmModal from the design system package',
    name: "ConfirmationDialog",
    components: {DialogCmp, DialogBtn},
    props: ['showDialog','content','actions', 'custom-title', 'size'],
    data() {
      return {
        dialog: false,
        dialogSize: "small"
      }
    },
    created() {
      if (this.size) {
        this.dialogSize = this.size
      }
    },
    computed: {
      containerClass() {
        let css = 'confirmation-dialog ' + this.dialogSize
        return css
      }
    },
    methods: {
      actionClicked($event,action) {
        this.$emit('confirmationActionClicked',$event, action,'')
      },
      closeDialog($event) {
        this.$emit("closeButtonPressed",false);
      },
    }
  };
</script>
<style lang="scss">
  @import "@/assets/scss/abstract/_variables.scss";

  .confirmation-dialog{

    height: 218px;
    min-height: 218px;

    &.small{
      width: 300px;
      min-height: auto;
    }

    &.medium{
      width: 570px;
    }

    .header-title{
      font-weight: 600;
      font-size: 24px;
      font-family: var(--font3);
    }
  }
</style>
